<template>

	<!-- content -->
	<div id="content" class="content board-list search-result">
		<div class="container" v-if="pageVO.isDisplay == true">
			<!-- 페이지 타이틀 -->
			<div class="page-title">
				<h2 class="tit">{{ pageVO.pageName }}</h2>
			</div>
			<!--			<div class="content" v-html="pageVO.contentHtml"></div>-->
			<html-open :html-code="pageVO.contentHtml"></html-open>
		</div>
		
		<div class="container m-b-40" v-else-if="Object.keys(pageVO).length !== 0">
			<div class="m-b-30">
				<div class="stats-icon">
					<i class="fa fa-exclamation-triangle width-100 height-100"></i>
				</div>
			</div>
			<div class="page-title">
				<h2 class="tit">해당 페이지를 찾지 못했습니다.</h2>
			</div>
			<div>
				<p>만료된 페이지거나 더 이상 제공되지 않는 페이지 입니다.</p>
			</div>
		</div>
	</div>
	<!--//content -->

</template>

<script>
import HtmlOpen from "@/components/display/htmlOpen";
export default {
	name: "appPage",
	components: {HtmlOpen},
	data () {

		return {
			pageCode: this.$route.params.PAGE_CODE,
			pageVO: {},
		}
	},
	created() {

		this.getStaicPage();

	},
	mounted() {

	},
	methods: {

		getStaicPage() {

			this.$eventBus.$emit("startProgress")
			this.axiosCaller.get(this, this.APIs.STATIC_PAGE + "/" + this.pageCode, {}, (res) => {

				this.$eventBus.$emit("doneProgress")
				const result = res.data
				if ( result.status === "ok" ) {
					this.pageVO = result.pageVO
				}

				if ( result.status === "fail" ) {
					this.swalUtils.gritter(result.status, result.msg, "warning", 3000)
				}

			})

		}

	}
}
</script>

<style scoped>

</style>